import { createFileRoute } from '@tanstack/react-router';
import TemplateDetailView from '../bulk-import/templates/detail/template-detail-view';
export const Route = createFileRoute('/bulk-import/templates/$templateId')({
  component: TemplateDetailView,
});
